import React from 'react';
import { Chip, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  AccountBalance,
  AccountBalanceWallet,
  Article,
  CreditCard,
  Payments,
} from '@mui/icons-material';
import {
  getMethodLabel,
  getMethodSummaryLabel,
  normalizeMethodType,
} from '../paymentNormalizer';

const ICONS = {
  ach: AccountBalance,
  transfer: AccountBalance,
  check: Article,
  cash: Payments,
  card: CreditCard,
  other: AccountBalanceWallet,
};

const COLOR_BY_TYPE = {
  ach: 'info',
  transfer: 'primary',
  check: 'secondary',
  cash: 'success',
  card: 'warning',
  other: 'info',
};

export default function PaymentMethodChip({ method, summary, mixed = false, size = 'small' }) {
  const theme = useTheme();
  const type = mixed ? 'other' : (summary?.type || method?.type || normalizeMethodType(method?.rawType || method));
  const Icon = ICONS[type] || AccountBalanceWallet;
  const paletteKey = mixed ? 'primary' : (COLOR_BY_TYPE[type] || 'default');
  const baseColor = paletteKey === 'default'
    ? theme.palette.text.secondary
    : theme.palette[paletteKey]?.main || theme.palette.text.secondary;
  const label = mixed
    ? 'Mixto'
    : summary
      ? getMethodSummaryLabel(summary)
      : getMethodLabel(method?.label || method?.rawType || method);

  return (
    <Chip
      size={size}
      variant="outlined"
      icon={<Icon fontSize="small" />}
      label={label}
      sx={{
        fontWeight: 500,
        color: baseColor,
        borderColor: alpha(baseColor, 0.34),
        bgcolor: alpha(baseColor, 0.07),
        maxWidth: '100%',
        '& .MuiChip-icon': { color: baseColor },
        '& .MuiChip-label': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      }}
    />
  );
}
